import 'round-slider';
import quiz from './home-quiz';
import { regularTemplate, rangeTemplate, circleTemplate, finshTemplate } from './question-templates';

function template(id, question) {
  if(id == 7) {
    questionRadioBtn(7);
    return regularTemplate(7, question);
  } else {
    if(question.template % 3 == 1) {
      questionRadioBtn(id);
      return regularTemplate(id, question);
    } else if(question.template % 3 == 2) {
      return rangeTemplate(id, question);
    } else if(question.template % 3 == 0) {
      setTimeout(function() {
        circle(id);
        circleRwd(id);
        circleBtn(id, question.set, question.template);
        circleQuestion('#question' + id, question.set, question.template);
      }, 200);
      return circleTemplate(id, question);
    }
  }
}

$('#questionContent1').html(template(1, quiz.getQuestion()));
questionRadioBtn(1);
$('.home-question[data-target-id="1"]').css('opacity','1');

$('.welcome__btn').on('click', function(){
  $('html, body').animate({
    scrollTop: $('#questionContent1').offset().top - 50
  }, 2000);
});

$('.question').on('click', '.home-scroll-btn', function (e){
  e.preventDefault();
  const target = $(this).attr('data-target-id');
  const question = $(this).attr('data-question-id');
  const temp = $(this).attr('data-template-id');
  if(temp % 3 == 1) {
    let idQuiz = $('.home-question__form[data-question-id="'+ question  +'"]').attr('data-id');
    let idValue = $('.home-question__form input[name=question'+ question +']:checked').val();
    quiz.setAnswer(idQuiz, idValue);
  } else if(temp % 3 == 2) {
    let idQuiz = $('.home-question__range[data-question-id="'+ question  +'"]').attr('data-id');
    let idValue = $('.range__input[data-question-id="'+question+'"]').val();
    (idValue < 50) ? idValue = idQuiz[0] : idValue = idQuiz[1];
    quiz.setAnswer(idQuiz, idValue);
  } else if(temp % 3 == 0) {
    let idQuiz = $('.circle-slider[data-question-id="'+ question  +'"]').attr('data-id');
    let idValue = $('#questionContent'+question+' .rs-handle').attr('aria-valuenow');
    if((idValue >= 0 && idValue < 12) || (idValue >=88 && idValue <= 100)) {
      idValue = idQuiz[0];
    } else if(idValue >= 12 && idValue < 38) {
      idValue = idQuiz[1];
    } else if(idValue >= 38 && idValue < 63) {
      idValue = idQuiz[0];
    } else if(idValue >= 63 && idValue < 88) {
      idValue = idQuiz[1];
    }
    quiz.setAnswer(idQuiz, idValue);
  }

  if(quiz.isResultReady() === true) {
    if(quiz.getResult().length == 1) {
      $('#finishContent').html(finshTemplate(quiz.getResult()));
      $('.dotted-path.line8').fadeIn(3000);
      setTimeout(function(){
        $('html, body').animate({
          scrollTop: $('#finishContent').offset().top - 50
        }, 2600);
      },200);
      setTimeout(function(){
        $('.home-question[data-target-id="8"]').css('opacity','1');
      },1000);
    }
  } else if(quiz.isResultReady() === false && (question == 6 || question == 7)) {
    $('#questionContent' + target).html(template(target, quiz.getQuestion()));
    scrollQuestion(target);
  } else {
    $('#questionContent' + target).html(template(target, quiz.getQuestion()));
    scrollQuestion(target);
  }
});


$('.question').on('click', '.range__btn', function() {
  const id = $(this).attr('data-question-id');
  const step = $(this).attr('data-range-step');
  $('.range__input[data-question-id='+id+']').val(step);
  
  enabledBtn(id);
});

$('.question').on('change', '.range__input', function() {
  const id = $(this).attr('data-question-id');
  let value = $('.range__input[data-question-id="'+id+'"]').val();
  (value != 50) ? enabledBtn(id) : disabledBtn(id);
});

function questionRadioBtn(id) {
  $('#questionContent'+ id).on('change', '.home-question__form[data-question-id="'+ id +'"]', function() {
    enabledBtn(id);
    const value = $('input[name=question'+ id +']:checked').val();
    const set = $('.home-question__form[data-question-id="'+ id +'"]').attr('data-set-id');
    const template = $('.home-question__form[data-question-id="'+ id +'"]').attr('data-template-id');
    const number = $('.home-question__form[data-question-id="'+ id +'"] input:checked').attr('data-photo-number');

    $('.home-question__form label').css('font-weight','400');
    $('input[name=question'+ id +']:checked').parent().css('font-weight','700');
    $('.home-question__img[data-question-id='+id+']').attr('src', '/raportcsr2018/assets/img/pytania/odp-'+ id +'-'+ set +'-'+ template +'-'+ number +'-'+ value +'.png');
  });
}

function circle(id) {
  if($(window).width() < 992) {
    $("#question"+ id).roundSlider({
      radius: 80,
      width: 8,
      handleSize: "+8",
      handleShape: "dot",
      sliderType: "min-range",
      value: 13,
      showTooltip: false
    });
  } else {
    $("#question"+ id).roundSlider({
      radius: 80,
      width: 8,
      handleSize: "+25",
      handleShape: "dot",
      sliderType: "min-range",
      value: 13,
      showTooltip: false
    });
  }
}

function circleRwd(id) {
  if($(window).width() >= 1200) {
    $('#question'+ id).css({'width':'400px', 'height':'400px'});
    $('.rs-container').css({'width':'400px', 'height':'400px'});
  } else if($(window).width() < 1200 && $(window).width() >= 992) {
    $('#question'+ id).css({'width':'220px', 'height':'220px'});
    $('.rs-container').css({'width':'220px', 'height':'220px'});
  } else if($(window).width() < 992 && $(window).width() >= 400) {
    $('#question'+ id).css({'width':'120px', 'height':'120px'});
    $('.rs-container').css({'width':'120px', 'height':'120px'});
  } else if($(window).width() < 400) {
    $('#question'+ id).css({'width':'100px', 'height':'100px'});
    $('.rs-container').css({'width':'100px', 'height':'100px'});
  } 
}

function circleBtn(id, set, template) {
  $('.question').on('click', '.circle-slider__btn[data-circle-id='+id+']', function() {
    $('.circle-slider__btn[data-circle-id="'+id+'"]').css('font-weight','normal');
    const step = $(this).attr('data-circle-step');
    const img = $(this).attr('data-circle-img');
    const type = $(this).attr('data-type');
    $('#question' + id).roundSlider({value: step});

    $(this).css('font-weight','bold');
    circleChangeImg(id, set, template, img, type);
    enabledBtn(id);
  });
}

function circleQuestion(id, set, template) {
  $('.question').on('change', id, function() {
    const question = $(id).attr('data-question-id');
    const type = $(id).attr('data-question-type');
    
    let val = $('#question'+question+' .rs-handle').attr('aria-valuenow');
    
    $('.circle-slider__btn[data-circle-id="'+question+'"]').css('font-weight','normal');
    if((val >= 0 && val < 12) || (val >=88 && val <= 100)) {
      $('.circle-slider__btn[data-circle-id="'+question+'"][data-circle-img="1"]').css('font-weight','bold');
      circleChangeImg(question, set, template, 1, type[0]);
    } else if(val >= 12 && val < 38) {
      $('.circle-slider__btn[data-circle-id="'+question+'"][data-circle-img="2"]').css('font-weight','bold');
      circleChangeImg(question, set, template, 2, type[1]);
    } else if(val >= 38 && val < 63) {
      $('.circle-slider__btn[data-circle-id="'+question+'"][data-circle-img="3"]').css('font-weight','bold');
      circleChangeImg(question, set, template, 3, type[1]);
    } else if(val >= 63 && val < 88) {
      $('.circle-slider__btn[data-circle-id="'+question+'"][data-circle-img="4"]').css('font-weight','bold');
      circleChangeImg(question, set, template, 4, type[0]);
    }
    enabledBtn(question);
  })
}

function circleChangeImg(id, set, template, img, type) {
  $('.circle-slider__img[data-question-id="'+ id +'"]').attr('src', '/raportcsr2018/assets/img/pytania/odp-'+id+'-'+set+'-'+template+'-'+img+'-'+type+'.png');
}

function enabledBtn(id) {
  $('.home-question__btn[data-question-id="'+ id +'"]').attr("disabled", false);
}
function disabledBtn(id) {
  $('.home-question__btn[data-question-id="'+ id +'"]').attr("disabled", true);
}

function scrollQuestion(target) {
  $('.dotted-path.line'+ target).fadeIn(3000);
  
  setTimeout(function(){
    $('html, body').animate({
      scrollTop: $('.home-question[data-target-id="'+target+'"]').offset().top - 50
    }, 2600);
  },200);
    
  setTimeout(function(){
    $('.home-question[data-target-id="'+target+'"]').css('opacity','1');
  },1000)
}